// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__-Bq6M","content":"RecentSearches_content__DxaZy"};